export default __webpack_public_path__ + "static/media/craon28.e6e438f3.jpg";